import { EnvironmentProviders, LOCALE_ID, makeEnvironmentProviders } from '@angular/core';
import { LOCALES_PATH } from './locale-loader';
import { LocaleProvider } from './locale-provider';
import { TRANSLATIONS_PATH } from './translation-loader';

export interface TranslationConfig {
  localesPath: string;
  translationsPath: string;
}

export function provideTranslations(config: TranslationConfig): EnvironmentProviders {
  const providers = [
    { provide: LOCALE_ID, useClass: LocaleProvider },
    { provide: LOCALES_PATH, useValue: config.localesPath },
    { provide: TRANSLATIONS_PATH, useValue: config.translationsPath },
  ];
  return makeEnvironmentProviders(providers);
}
